import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { CustomerProfile } from '@/models';
import { CountryCode } from '@/store/ui';
import { ui, countries } from '@/constants';

@Component({
  name: 'CmgLostBagModal',
})
export default class CmgLostBagModal extends Vue {
  isLeaving = false;

  get visible(): boolean {
    return this.$appStore.state.ui.modals.lostBagModal.visible;
  }

  get countryName(): string {
    return this.$appStore.state.ui.countryProfile.name;
  }

  get isMobile(): boolean {
    return this.$appStore.state.ui.clientWidth <= ui.breakpoints.phoneLgMax;
  }

  get closeButtonImageUrl(): string {
    return this.$appStore.state.cms.images.buttons.xDarkBrown.default;
  }

  get customer(): CustomerProfile | null {
    const profile = this.$appStore.state.customer.profile;
    return profile && !profile.isGuest ? profile : null;
  }

  get profileCountryCode(): string {
    return this.customer ? (this.customer.country || CountryCode.US) : '';
  }

  onStay(): void {
    this.onClose();
  }

  async onLeave(): Promise<void> {
    this.isLeaving = true;

    try {
      this.$services.order.resetPendingOrder();
      await this.$services.restaurant.selectRestaurant(null, true);
      await this.$services.order.setDeliveryAddress(null);

      this.$services.ui.setCountryProfile(countries[this.profileCountryCode.toLowerCase()], true);
    } catch (e) {
      this.$services.logger.error('Error switching countries', e);
    } finally {
      this.isLeaving = false;
      this.onClose();
    }
  }

  onClose() {
    this.$services.ui.setModalVisibility('lostBagModal', false);
  }
}
